import styled from "styled-components";
import { devices } from "../../Theme.css";

export const MenuItem = styled.div`
  padding: 8px 24px;


  @media ${devices.max_sm} {
    width: 100vw;
  }

  .row {
    min-width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .message {
    width: 80%;
  }

  .icons {
    width: 20%;
    display: flex;
    justify-content: flex-end;
  }
  .time-ago {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-size: 12px;
    color: #aaa;
    font-weight: bold;
  } 
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  &:hover {
    background: rgba(238, 90, 41, 0.2);
    border-radius: 50%;
  }
`;

export const ReactionContainer = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }
`;
